import Head from 'expo-router/head';

import { AuthContainer, SignIn } from '@fhs/auth';

export default function AuthOAuthEntryPage() {
  return (
    <>
      <Head>
        <title>Authorize - Firehouse Subs</title>
      </Head>
      <AuthContainer>
        <SignIn />
      </AuthContainer>
    </>
  );
}
